<div class="create-form">
  <div fxLayout="row" fxLayoutAlign="center none">
    <form
      (ngSubmit)="submit()"
      novalidate
      [formGroup]="avenueForm"
      fxFlex="85"
      fxFlex.lt-md="100"
      fxLayout="column"
      fxLayoutAlign="center stretch"
      >
      <section class="custom-label-container">
        <span class="custom-label-value">Details</span>
        <div class="custom-label-underline"></div>
      </section>

      <div class="required">Required *</div>

      <!-- Activity Name -->
      <mat-form-field class="create-form__displayName">
        <mat-label>Title</mat-label>
        <input
          matInput
          type="text"
          formControlName="displayName"
          (keyup)="onChange()"
          />
        <mat-error
          print-error
          [control]="avenueForm.get('displayName')"
          fieldName="Title"
          >
        </mat-error>
      </mat-form-field>

      <!-- Activity Description -->
      <div>
        <label
          >Instructions *
          <text-editor
            placeholder="Instructions *"
            formControlName="description"
            [required]="true"
            (onContentChanged)="onChange()"
            (setQuillEditorTouched)="setQuillEditorTouched()"
          ></text-editor>
        </label>
        <mat-error
          print-error
          [control]="avenueForm.get('description')"
          fieldName="Instructions"
          >
        </mat-error>
      </div>

      <!-- Activity Unit and Level -->
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-sm="center stretch"
        class="margin-top-20px"
        >
        <div fxFlex="47" fxFlex.lt-sm="100">
          @if (subjectId && !isMath(subjectId)) {
            <mat-form-field>
              <mat-label>Unit</mat-label>
              <mat-select
                formControlName="unit"
                (selectionChange)="onChange()"
                >
                @for (unit of avenueUnits; track unit) {
                  <mat-option
                    [value]="unit"
                    >
                    {{ unit }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-form-field>
            <mat-label>{{ levelLabel }}</mat-label>
            <mat-select
              formControlName="levelIds"
              (selectionChange)="onChange()"
              >
              @for (level of avenueLevels; track level) {
                <mat-option
                  [value]="level.levelId"
                  >
                  {{ level.levelName }}
                </mat-option>
              }
            </mat-select>
            <mat-error
              print-error
              [control]="avenueForm.get('levelIds')"
              fieldName="{{ levelLabel }}"
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Activity Views and Media Time -->
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-sm="center stretch"
        >
        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-form-field class="create-form__views">
            <mat-label>Views</mat-label>
            <mat-select
              formControlName="views"
              (selectionChange)="onChange()"
              >
              @for (opt of viewsTriesOpts; track opt) {
                <mat-option
                  [value]="opt.key"
                  >
                  {{ opt.value }}
                </mat-option>
              }
            </mat-select>
            <mat-error
              print-error
              [control]="avenueForm.get('views')"
              fieldName="Views"
              >
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-form-field class="create-form__mediaTime">
            <mat-label>Media Time</mat-label>
            <mat-select
              formControlName="mediaTime"
              (selectionChange)="onChange()"
              >
              @for (opt of timeOpts; track opt) {
                <mat-option
                  [value]="opt.key"
                  >
                  {{ opt.value }}
                </mat-option>
              }
            </mat-select>
            <mat-error
              print-error
              [control]="avenueForm.get('mediaTime')"
              fieldName="Media time"
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Activity Record Time -->
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-sm="center stretch"
        >
        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-form-field class="create-form__recordingTries">
            <mat-label>Tries</mat-label>
            <mat-select
              formControlName="recordingTries"
              (selectionChange)="onChange()"
              >
              @for (opt of viewsTriesOpts; track opt) {
                <mat-option
                  [value]="opt.key"
                  >
                  {{ opt.value }}
                </mat-option>
              }
            </mat-select>
            <mat-error
              print-error
              [control]="avenueForm.get('recordingTries')"
              fieldName="Tries"
              >
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-form-field class="create-form__recordTime">
            <mat-label>Record Time</mat-label>
            <mat-select
              formControlName="recordTime"
              (selectionChange)="onChange()"
              >
              @for (opt of timeOptions; track opt) {
                <mat-option
                  [value]="opt.key"
                  >
                  {{ opt.value }}
                </mat-option>
              }
            </mat-select>
            <mat-error
              print-error
              [control]="avenueForm.get('recordTime')"
              fieldName="Record time"
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Avenue checkboxes -->
      <div
        fxLayout="row"
        fxLayout.lt-lg="column"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-lg="center stretch"
        class="margin-top-20px"
        >
        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-checkbox
            formControlName="allowPause"
            (change)="onChange()"
            >
            Allow student to pause recording
          </mat-checkbox>
        </div>
        <div fxFlex="47" fxFlex.lt-sm="100">
          <mat-checkbox
            formControlName="mediaWhileRecording"
            (change)="onChange()"
            >
            Show media while student records
          </mat-checkbox>
        </div>
      </div>

      <!-- Activity visibility -->
      <mat-form-field class="create-form__visibility margin-top-20px">
        <mat-label>Share With</mat-label>
        <mat-select
          formControlName="visibility"
          (selectionChange)="onChange()"
          >
          @for (opt of visibilityOpts; track opt) {
            <mat-option
              [value]="opt.key"
              >
              {{ opt.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Distributor Only parameters -->
      @if (isDistributor) {
        <div class="distributor-border">
          <div class="metadata-title">Activity Metadata</div>
          <div
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="center center"
            class="form-row"
            >
            <mat-form-field class="create-form__lesson">
              <mat-label>Lesson</mat-label>
              <input
                matInput
                trimInput
                type="text"
                formControlName="lesson"
                (change)="onChange()"
                />
            </mat-form-field>
            <mat-form-field class="create-form__activityNumber">
              <mat-label>Activity Number</mat-label>
              <input
                matInput
                type="text"
                formControlName="activityNumber"
                (change)="onChange()"
                />
            </mat-form-field>
          </div>
          <div
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="center center"
            class="form-row"
            >
            <mat-form-field class="create-form__bookId">
              <mat-label>Book ID</mat-label>
              <input
                matInput
                trimInput
                type="text"
                placeholder="Book ID"
                formControlName="bookId"
                (change)="onChange()"
                />
            </mat-form-field>
            <mat-form-field class="create-form__page">
              <mat-label>Page Number</mat-label>
              <input
                matInput
                trimInput
                type="text"
                formControlName="page"
                (change)="onChange()"
                />
            </mat-form-field>
          </div>
        </div>
      }

      <!-- Avenue Assets -->
      @if (!!activeProgram) {
        <avenue-assets
          class="margin-top-20px"
          [initSelectedAssetID]="selectedAssetID"
          [activeProgram]="activeProgram"
          [selectedEdition]="selectedEdition"
          (onSelectedAsset)="onSelectAsset($event)"
        ></avenue-assets>
      }
      @if (
        avenueForm.get('parentAssetId')?.hasError('required') &&
        !avenueForm.pristine
        ) {
        <mat-error
          >
          Media is required
        </mat-error>
      }
    </form>
  </div>
</div>
